export var DEPLOY_DATE = new Date('2026-07-17T06:50:57+0000');
